/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { PvpFightLib, PvpFightLibInterface } from "../PvpFightLib";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
    ],
    name: "ErrorHeroIsNotRegistered",
    type: "error",
  },
  {
    inputs: [],
    name: "ErrorPaused",
    type: "error",
  },
  {
    inputs: [],
    name: "NoDominationRequest",
    type: "error",
  },
  {
    inputs: [],
    name: "NotGuildMember",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        internalType: "uint32",
        name: "week",
        type: "uint32",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "PvpFightIsCompleted",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        internalType: "uint32",
        name: "week",
        type: "uint32",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "PvpFightIsNotPrepared",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint48",
        name: "fightId",
        type: "uint48",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "items",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "itemIds",
        type: "uint256[]",
      },
    ],
    name: "AddPvpFightItems",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "completed",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "totalCountFights",
            type: "uint8",
          },
          {
            internalType: "uint32",
            name: "healthHero",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "healthOpponent",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "manaConsumedHero",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "manaConsumedOpponent",
            type: "uint32",
          },
        ],
        indexed: false,
        internalType: "struct IPvpController.PvpFightResults",
        name: "fightResult",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "uint48",
        name: "fightId",
        type: "uint48",
      },
      {
        indexed: false,
        internalType: "address[2]",
        name: "heroes",
        type: "address[2]",
      },
      {
        indexed: false,
        internalType: "uint64[2]",
        name: "guilds",
        type: "uint64[2]",
      },
      {
        indexed: false,
        internalType: "bool[2]",
        name: "winners",
        type: "bool[2]",
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "prizes",
        type: "uint256[2]",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "technicalDefeat",
        type: "bool",
      },
    ],
    name: "PvpFightCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "week",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "manuallyRemoved",
        type: "bool",
      },
    ],
    name: "PvpHeroRemoved",
    type: "event",
  },
] as const;

export class PvpFightLib__factory {
  static readonly abi = _abi;
  static createInterface(): PvpFightLibInterface {
    return new Interface(_abi) as PvpFightLibInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): PvpFightLib {
    return new Contract(address, _abi, runner) as unknown as PvpFightLib;
  }
}
